import MetricBox from "components-for/display/metric-box";
import { FunctionComponent, memo } from "react";
import { IProps } from "./agents-count-metric.types";
import { LIVE_POLL_INTERVAL_MILLISECONDS } from "constants/pages/live";
import { parseUrlArray } from "@edgetier/utilities";
import { useAgentsCount } from "hooks-for/agents/use-agent-counts";
import { useQueryParameters } from "@edgetier/client-components";
import "./agents-count-metric.scss";

/**
 * Count agents matching some parameters.
 * @param props.queryParameters Parameters for the agents route.
 * @param otherProps            Metric props.
 * @returns                     Count of agents metric.
 */
const AgentsCountMetric: FunctionComponent<IProps> = ({ queryParameters = {}, ...otherProps }) => {
    const { tagId } = useQueryParameters({ tagId: parseUrlArray });
    const parameters = { ...queryParameters, tagId };
    const { data, isLoading } = useAgentsCount(parameters, { refetchInterval: LIVE_POLL_INTERVAL_MILLISECONDS });
    return <MetricBox isLoading={isLoading} value={data ?? null} {...otherProps} />;
};

export default memo(AgentsCountMetric);
